export default __webpack_public_path__ + "static/media/425.2242789d.png";